import { createContext } from "react";

const DF_OT0023Context = createContext();

export { DF_OT0023Context };